var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-multiline",attrs:{"id":_vm.id}},_vm._l((_vm.config.fields),function(field,index){return _c('div',{key:field.name,staticClass:"column",class:{'is-half':_vm.config.dual,'is-full':!_vm.config.dual}},[_c('bulmaField',{attrs:{"id":field.name,"data":field}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }